import { useLoader } from "@react-three/fiber";
import * as THREE from "three";

import { Pillar } from "./Pillar";

export interface OverheadProps {
  position: [number, number, number];
  url: string;
}

export function Overhead({ position, url }: OverheadProps) {
  const [x, y, z] = position;

  const texture = useLoader(THREE.TextureLoader, url);
  texture.colorSpace = THREE.SRGBColorSpace;
  texture.magFilter = THREE.NearestFilter;
  texture.minFilter = THREE.NearestFilter;

  return (
    <mesh position={position}>
      <mesh position={[x, y + 4, z]}>
        <planeGeometry args={[10, 4, 1, 1]} />
        <meshBasicMaterial map={texture} side={THREE.DoubleSide} />
      </mesh>
      <Pillar position={[x + 5.5, y, z]} />
      <Pillar position={[x - 5.5, y, z]} />
      <Pillar position={[x, y + 6.5, z]} rotationZ={Math.PI / 2} />
    </mesh>
  );
}
